import {NgModule} from '@angular/core';
import {Route, RouterModule, Routes} from '@angular/router';
import {ElementFormComponent} from './element-form/element-form.component';
import {TechnicalDeviceResolver} from './services/technical-device.resolver';
import {TechnicalDeviceGroupsWithParamsResolver} from './services/technical-device-groups-with-params.resolver';

export const elementRoutes: Route[] = [
    {
        path: ':technicalDeviceId/new',
        component: ElementFormComponent,
        resolve: {
            technicalDevice: TechnicalDeviceResolver,
            elementGroupsWithParams: TechnicalDeviceGroupsWithParamsResolver,
        },
        data: {
            title: 'Элемент контроля'
        }
    },
];

@NgModule({
    imports: [
        RouterModule.forChild([]),
    ],
    exports: [
        RouterModule
    ]
})
export class ElementRoutingModule {
}
